/**
 * Strip the entries a user removed before sending a settings list to the API.
 *
 * These settings forms mark a removed row with a form-local `isDeleted` flag so
 * the row can disappear from the list without losing the rest of the form state.
 * That flag is ours, not the API's: the rota settings endpoints delete by
 * omission, and reject any payload that still carries a flagged entry —
 * `PUT /v5/list/homes/:id/rota` answers 400 "Field [id] is invalid", and the
 * shift-types endpoint 500s on the same shape. The forms already hide flagged
 * rows from the user, so before this they looked deleted while every save failed
 * (ROST-3504).
 */
export const withoutDeletedEntries = <T extends { isDeleted?: boolean }>(
  entries: T[] = []
): Array<Omit<T, 'isDeleted'>> =>
  entries
    .filter((entry) => entry?.isDeleted !== true)
    .map(({ isDeleted, ...entry }) => entry)
